import { Component, OnInit } from '@angular/core';
import { StorageService, StorageType } from '@rct/lynx-lobbies-shared-lib';
import { LYNX_STORAGE_KEYS } from '../../core/constants/lynx-storage-keys.constant';
import { ErrorMessage } from '../../core/interfaces/error-message';
import { LynxLocalizeRouterService } from '../../core/services/localize-router.service';

@Component({
    selector: 'lynx-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: false
})
export class PageNotFoundComponent implements OnInit {
  message: ErrorMessage;
  constructor(
    private storageService: StorageService,
    private localizeRouterService: LynxLocalizeRouterService
  ) {}

  ngOnInit(): void {
    const lobbyId = this.storageService.get(
      LYNX_STORAGE_KEYS.lobbyId,
      StorageType.Session
    );
    const lobbyExist = lobbyId ? true : false;
    this.message = {
      title: 'Error.PageNotFound.Title',
      description: lobbyExist
        ? ['Error.PageNotFound.Description.General.0', 'Error.PageNotFound.Description.General.1']
        : ['Error.PageNotFound.Description.LobbyNotExist'],
      hasButton: lobbyExist ? true : false,
      data: {
        LobbyID: lobbyId
      }
    };
  }

  backToHome() {
    this.localizeRouterService.translateRoute('home');
  }
}
